/*
 * @Author: lc
 * @Date: 2022-07-26 15:09:06
 * @LastEditors: lc
 * @LastEditTime: 2022-07-27 11:40:27
 * @Description: 上链藏品
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const collectionchain = {
    // 列表
    list (params) {
        return axios.get(api + 'collectionchain/list', { params: params })
    },
    detail (params) {
        return axios.get(api + 'collectionchain/detail', { params: params })
    },
    // 审核
    review (params) {
        return axios.post(api + 'collectionchain/review', qs.stringify(params))
    },

}


// 导出接口
export default collectionchain

